export var SynergyBannerAction;
(function (SynergyBannerAction) {
    SynergyBannerAction["VIEW"] = "view_banner_synergy";
    SynergyBannerAction["CLICK"] = "banner_synergy_click";
})(SynergyBannerAction || (SynergyBannerAction = {}));
export const SYNERGY_BANNER_ID = 'synergy-banner';
